import React, { useEffect, useContext, useState, useRef } from "react";
import { TokenVerificationLoggedin, BlockAdmin } from "../../utils/tokenVerify";
import { LoadingContext } from "react-router-loading";
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../../config/config.json";
import { Table, Tooltip, Select, Col, Row, Pagination, Input } from 'antd';
import { Link } from 'react-router-dom'
import FullLoader from "../../assets/images/full-page-loader.gif"
import prevIcon from '../../assets/images/icons/chevron-left.svg';
import nextIcon from '../../assets/images/icons/chevron-right.svg';
import noData from '../../assets/images/data-graph/no-data.svg';
import TableLoader from "../TableLoader";
import errorData from '../../assets/images/data-graph/error-data.svg';
import { notifyfailure, notifysuccess, notifycatch } from "../../utils/toast";

const AdminCheckAdcodesList = () => {

    const loadingContext = useContext(LoadingContext);
    const [apiCall, setApicall] = useState(false)

    const columnsAll = [
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            // render: (data) => <div className='badge_content--approved'>{data}</div>,
            fixed: 'left',
            width: 60,
            render: (text, record) => <div className='w_100 position-relative'>

                {text === "processing" || text === "completed" ?
                    <Select
                        className={text === "processing" ? `form_select badge_content--pending` : `form_select badge_content--approved`}
                        dropdownStyle={{
                            width: '12rem'
                        }}
                        style={{ pointerEvents: "none" }}
                        value={text}
                        options={
                            [{ label: "Processing", value: "processing" }, { label: "Completed", value: "completed" }]
                        }
                    />
                    :
                    <Select
                        className="form_select badge_content--new"
                        dropdownStyle={{
                            width: '12rem'
                        }}
                        value={text}
                        options={
                            [{ label: "Pending", value: "pending" }, { label: "Processing", value: "processing" }]
                        }
                        onChange={(event) => {

                            let status = Cookies.get("token_xapads_ssp") ? true : false;
                            if (status) {
                                let token = Cookies.get("token_xapads_ssp");

                                let payload = {
                                    "status": event,
                                }

                                setLoading(true)
                                axios
                                    .post(configData.SERVER_URL + `adcodes/uploadUrl?_id=` + record?._id, payload, {
                                        headers: {
                                            "Content-Type": "application/json",
                                            "x-access-token": token,
                                        },
                                    })
                                    .then((response) => {
                                        setApicall(!apiCall)
                                        notifysuccess(response.data.message);

                                    })
                                    .catch((error) => {
                                        if (error.response.data.message?.length !== 0) {
                                            notifyfailure(error.response.data.message)
                                        }
                                        else {
                                            notifycatch()
                                        }
                                        setLoading(false)

                                    });

                            }
                        }
                        }
                    />
                }
            </div>,

        },
        {
            title: "Adcodes",
            dataIndex: "adcodes",
            width: 530,
            key: "adcodes",
            // fixed: 'left',
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (text) => {

                if (!Array.isArray(text)) {
                    text = []
                }


                return (
                    <div className="multi_adcodes_main" >
                        {(text.length === 0) ?
                            <>
                                <div className='text_dark'>-</div>
                            </>
                            :
                            <>
                                {
                                    text.map((data, index) => (
                                        <div key={index} className={(text.length - 1) === index ? "multi_adcodes multi_adcodes_last" : "multi_adcodes"}>
                                            <>
                                                {data?.map((item, index2) => (

                                                    <>
                                                        <span className="adocde_span_design2" key={index2} style={{ marginRight: "8px" }}

                                                        >
                                                            <Tooltip title={item.condition === "" ? "case insensitive" : item.condition}>
                                                                {item.value}
                                                            </Tooltip>
                                                        </span>
                                                        {(index2 !== data?.length - 1) && <span>,</span>}
                                                    </>

                                                ))}


                                            </>

                                        </div>
                                    ))}
                            </>

                        }
                    </div>
                )
            },
        },

        {
            title: "Created By",
            dataIndex: "created_by",
            width: 110,
            key: "created_by",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
        {
            title: "Created At",
            dataIndex: "createdAt",
            width: 100,
            key: "createdAt",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
    ];

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [initialLoad, setInitialLoad] = useState(true)

    const [page, setPage] = useState({
        current: 1,
        pageSize: 50,
        total: 10,
    });



    const [sort, setSort] = useState({
        name: "",
        type: ""
    });

    const [search, setSearch] = useState("")


    const getData = () => {
        setLoading(true)
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .get(configData.SERVER_URL + `adcodes/list?sort=${sort.name}&order=${sort.type}&search=${search}&limit=${page.pageSize}&page=${page.current}`, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    setData(response.data.data.data)
                    if (response.data.data.data.length > 0) {
                        let tempPage = { ...page }
                        tempPage.total = response.data.data.metaData?.totalRecords

                        setPage(tempPage)
                    }

                    setLoading(false)
                    setInitialLoad(false)
                })
                .catch((error) => {
                    setData([])
                    setLoading(false)
                    setInitialLoad(false)
                });
        }

    }

    useEffect(() => {
        TokenVerificationLoggedin();
        BlockAdmin()
        getData()
        loadingContext.done()
    }, [loadingContext]);



    useEffect(() => {
        if (!initialLoad) {
            getData()
        }
    }, [apiCall])

    useEffect(() => {
        if (!initialLoad) {
            const delayDebounceFn = setTimeout(() => {
                let tempPage = page
                tempPage.current = 1
                setPage(tempPage);
                setApicall(!apiCall)
            }, 400); // 500ms delay
            // Cleanup function to clear the timeout if query changes
            return () => clearTimeout(delayDebounceFn);
        }
    }, [search]);



    const handleTableChange = (pagination, filters, sorter) => {
        setSort({ name: sorter.field, type: sorter.order });
        setApicall(!apiCall)
    };

    const handlePageChange = (data) => {

        let tempPage = page
        tempPage.current = data
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const handlePageSizeChange = (e) => {
        let tempPage = page
        tempPage.pageSize = e

        if (tempPage.current > 1) {
            if (e * tempPage.current > tempPage.total) {
                tempPage.current = tempPage.current - 1
            }
        }
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <Link><img src={prevIcon} alt='USP' /></Link>;
        }
        if (type === 'next') {
            return <Link><img src={nextIcon} alt='USP' /></Link>;
        }
        return originalElement;
    };


    const locale = {
        emptyText:
            <>{search.trim().length > 0 && loading ?
                <div className='no_data_screen'>
                    <div className='text-center'>

                        <div className='float_text_div'>

                        </div>
                    </div>
                </div>
                :
                search.trim().length > 0 && !loading ?
                    <div className='no_data_screen'>
                        <div className='text-center'>
                            <img src={errorData} className='' alt="" />
                            <div className='float_text_div'>

                            </div>
                        </div>
                    </div>
                    :

                    loading ?
                        <div className='no_data_screen'>
                            <div className='text-center'>

                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
                        :
                        <div className='no_data_screen' >
                            <div className='text-center'>
                                <img src={noData} className='' alt="" />
                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
            }
            </>

    };

    return (
        <>


            <div className="container_box--wrapper pt_header"
            >
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <h1 className="heading fw_600">
                        Adcodes History
                    </h1>
                </div>

                <div className={data.length > 0 ? "table_and_filter_div --without_filter_div" : "table_and_filter_div --without_filter_div --no_data_div_height"}>
                    <div className="table_area_div">
                        <div className="searchbar_with_btns">
                            <div className="d_flex justify_content_between">
                                <div className="form_content_block--group">
                                    {!initialLoad &&
                                        <Input
                                            type='text'
                                            className='form_control basic md search_input w_table_search'
                                            placeholder="Search"
                                            value={search}
                                            onChange={(e) => {

                                                if (e.target.value.trim().length === 0) {
                                                    setLoading(true)
                                                }

                                                setSearch(e.target.value)
                                            }}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="table_content--box --new_layout_table_design table_empty_screen_d2 check_adcodes_listing">
                            {loading && !initialLoad &&
                                <div className="table_new_loader_d2">
                                    <img src={FullLoader} className="img-fluid" alt="" />
                                </div>
                            }

                            {initialLoad ?
                                <TableLoader />
                                :
                                <Table
                                    columns={columnsAll}
                                    pageSize={100}
                                    dataSource={data}
                                    onChange={handleTableChange}
                                    pagination={false}
                                    rowKey={(record) => record.id}
                                    locale={locale}
                                    scroll={{ x: 1500, y: 'calc(100vh - 30.9rem' }} />
                            }

                            {data.length > 0 &&
                                <Row className="custom_pagination--container">
                                    <Col span={6}>
                                        <div className="form_content_block--group mb_0">
                                            <Select
                                                className='form_select basic sm no_search'
                                                value={page.pageSize}
                                                onChange={handlePageSizeChange}
                                                style={{ width: 80 }}
                                                showSearch={false}
                                                options={[
                                                    { value: 10, label: 10 },
                                                    { value: 20, label: 20 },
                                                    { value: 50, label: 50 },
                                                    { value: 100, label: 100 },
                                                ]} />
                                            <label className='custom_pagination--label'>
                                                items per page
                                            </label>
                                        </div>
                                    </Col>
                                    <Col span={6}>
                                        <span className="custom_pagination--total-text">
                                            {`${(page.current - 1) * page.pageSize + 1}-${Math.min(page.current * page.pageSize, page.total)} of ${page.total} items`}
                                        </span>
                                    </Col>
                                    <Col span={6}>
                                        <Pagination
                                            current={page.current}
                                            pageSize={page.pageSize}
                                            total={page.total}
                                            onChange={handlePageChange}
                                            showSizeChanger={false}
                                            itemRender={itemRender}
                                            className="custom_pagination" />
                                    </Col>
                                </Row>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminCheckAdcodesList;
